module.exports = __webpack_public_path__ + "static/reyjs-ebd1c217f6d5e6e560f8b029c0232f18.svg";